export { storePatchesReducer } from './storePatches';
